import { render, staticRenderFns } from "./FSCopyright.vue?vue&type=template&id=2f87b5c3&"
import script from "./FSCopyright.vue?vue&type=script&lang=js&"
export * from "./FSCopyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports